import { Component, OnInit } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { PrimaryButtonComponent } from '../primary-button/primary-button.component';
import { SecondaryButtonComponent } from '../secondary-button/secondary-button.component';
import { ConsentService } from './consent.service';

@Component({
    selector: 'pax-cookie-banner',
    standalone: true,
    imports: [PrimaryButtonComponent, SecondaryButtonComponent, LucideAngularModule],
    template: `
        @if (showBanner) {
            <div class="flex fixed inset-0 z-[1000]  items-end bg-black bg-opacity-50">
                <div class="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-lg">
                    <div class="p-4 mx-auto max-w-7xl md:p-6">
                        <div class="flex flex-col gap-4 md:flex-row md:items-center">
                            <lucide-icon
                                [absoluteStrokeWidth]="true"
                                name="cookie"
                                size="80"
                                class="w-[24px] h-[24px] md:w-[80px] md:h-[80px]"
                                strokeWidth="2"
                            ></lucide-icon>
                            <div class="flex-1">
                                <h3 class="mb-2 text-lg font-semibold">Helfen Sie uns, Ihr Erlebnis zu verbessern</h3>
                                <p class="text-sm text-gray-600">
                                    Wir verwenden Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu bieten. Dazu zählen Cookies, die für den Betrieb der Seite
                                    notwendig sind, sowie solche, die für Statistikzwecke und zur Anzeige personalisierter Inhalte genutzt werden.
                                </p>
                            </div>
                            <div class="flex gap-3 mt-4 md:mt-0">
                                <pax-secondary-button (click)="rejectAll()"> Ablehnen </pax-secondary-button>
                                <pax-primary-button (click)="acceptAll()"> Akzeptieren </pax-primary-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    `,
})
export class CookieBannerComponent implements OnInit {
    // TODO: redesign and use cookies to store consent
    showBanner = true;

    constructor(private consentService: ConsentService) {}

    ngOnInit() {
        // Check if user has already provided consent
        this.showBanner = !localStorage.getItem('userConsent');
    }

    acceptAll() {
        this.consentService.updateConsent({
            ad_storage: true,
            analytics_storage: true,
            functionality_storage: true,
            personalization_storage: true,
        });
        this.showBanner = false;
    }

    rejectAll() {
        this.consentService.updateConsent({
            ad_storage: false,
            analytics_storage: false,
            functionality_storage: false,
            personalization_storage: false,
        });
        this.showBanner = false;
    }
}
